import React, { useState, useEffect } from "react";
import axios from "axios";
import { get } from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";
import { LargeCard } from "../Cards/LargeCard";
import { CDBModal } from "cdbreact";
import { ModalReports } from "../Modals/ModalReports";
import Swal from "sweetalert2";

const usersheaders = [
  "Código SAP",
  "Descripción",
  "Código Proveedor",
  "Proveedor",
  "Rop",
  "Cant. mínimo",
  "Cant. máximo",
  "Cant. Inventario",
  "% Inventario",
  "Cant. a enviar",
  "Fecha",
  "Acción",
];

export const CrudSkusRecord = ({ userName, project }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [state, setState] = useState({ modal6: false });
  const [action, setAction] = useState("");
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [skus, setSkus] = useState([]);
  const [providers, setProviders] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const defaultFormData = {
    selectedOptions: [],
    TimeStart: "",
    TimeEnd: "",
    selectedUser: "",
    selectedCodeSap: "",
    smallerThanRop: "",
    greaterThanRop: "",
    smallerThanCantidadEnvio: "",
    greaterThanCantidadEnvio: "",
    smallerThanPorcentajeInventario: "",
    greaterThanPorcentajeInventario: "",
  };

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const getData = async (search, statusPage) => {
    try {
      setLoading(true);
      const response = await get(
        `/skus?page=${statusPage}&search=${search}&Nit=${project}&skusHistory=${true}&limit=${itemsPerPage}`
      );
      if (response && response.answer) {
        setTotalItems(response.pagination.totalItems);
      } else {
        setTotalItems(0);
      }
      setData(response ? response.items : []);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener los datos de los SKUs. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
    }
  };

  const getSku = async () => {
    try {
      const response = await get(`/skus?Nit=${project}&Lista=True`);
      setSkus(response.items);
    } catch (error) {
      console.error("Error al obtener los SKUs:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener los SKUs. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
    }
  };

  const getProviders = async () => {
    try {
      const response = await get(`/projects?Nit=${project}&list=${true}`);
      if (response && response.items) {
        setProviders(response.items);
      } else {
        console.error("Error fetching providers: No items found in response");
        setProviders([]);
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      setProviders([]);
      Swal.fire({
        title: "Error",
        text: "Error al obtener los proveedores. Por favor, inténtelo de nuevo más tarde.",
        icon: "error",
        confirmButtonColor: "#146284",
      });
    }
  };

  const handleSubmit = () => {
    const requiredFields = formData.selectedOptions;

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      Swal.fire({
        title: "Error!",
        text: "Por favor, rellene todos los campos",
        icon: "error",
        confirmButtonColor: "#146284",
      });
      setLoading(false);
      return false;
    }

    return true;
  };

  const toggle = (nr) => () => {
    let modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const closeModal = () => {
    setState({ ...state, modal6: false });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const documentGenerate = async () => {
    try {
      // Convertir TimeStart y TimeEnd a formato ISO solo con la fecha (sin horas)
      if (formData.TimeStart && formData.TimeEnd) {
        const timeStart = new Date(formData.TimeStart);
        const timeEnd = new Date(formData.TimeEnd);
  
        // Convertir las fechas a formato ISO (YYYY-MM-DD)
        formData.TimeStart = timeStart.toISOString().split('T')[0];
        formData.TimeEnd = timeEnd.toISOString().split('T')[0];
      }
  
      const response = await axios.get(`/skus?documentGenerate=${true}`, {
        params: formData,
      });
  
      if (response.status === 200) {
        // Notificar al usuario que se inició la generación del reporte
        Swal.fire({
          title: "Generación Iniciada",
          text: "Se ha iniciado la generación del reporte. Te notificaremos cuando esté disponible.",
          icon: "success",
          confirmButtonColor: "#146284",
        });
      } else {
        // Mostrar mensaje de error genérico
        Swal.fire({
          title: "Error",
          text: "Error al generar el informe. Por favor, verifica la información.",
          icon: "error",
          confirmButtonColor: "#146284",
        });
      }
    } catch (error) {
      // Manejar error
      console.error("Error generando el informe:", error);
      Swal.fire({
        title: "Error",
        text: "Error al generar el informe. Por favor, verifica la información.",
        icon: "error",
        confirmButtonColor: "#146284",
      });
    }
  
    setFormData(defaultFormData);
  };  

  const convertDataToArray = () => {
    try {
      return data.map((item) => [
        (item.CodeSap || "").toUpperCase(),
        (item.SkuDescription || "").toUpperCase(),
        (item.Nit || "").toUpperCase(),
        (item.ProjectName || "").toUpperCase(),
        parseFloat(item.Rop).toFixed(2) || "0.00",
        parseFloat(item.SkuMin).toFixed(2) || "0.00",
        parseFloat(item.SkuMax).toFixed(2) || "0.00",
        parseFloat(item.Inventory).toFixed(2) || "0.00",
        `${parseFloat(item.PercentInventory).toFixed(2) || "0.00"}%`,
        parseFloat(item.SendQuantity).toFixed(2) || "0.00",
        item.HistorialDate,
        item.ActionCreate,
      ]);
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, page);
    } else {
      setChangePage(false);
    }
  }, [page, initialRender]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "submitModal":
        const success = handleSubmit();
        if (success) {
          documentGenerate();
          toggle(6)();
        }
        break;
      case "refresh":
        getData("", page);
        break;
      case "reports":
        getProviders();
        getSku();
        toggle(6)();
        break;
      case "closeModal":
        toggle(6)();
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name={"Historial de Skus"}
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setPressedButton={setPressedButton}
        setSearch={setSearch}
        cState={false}
        reportState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        colorPorcentage={true}
      />
      <CDBModal isOpen={state.modal6} toggle={toggle(6)}>
        <ModalReports
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          skus={skus}
          origin={"SKUS"}
          providers={providers}
        />
      </CDBModal>
    </>
  );
};
